import { mods } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { AttachmentCellProps } from './AttachmentCell.types';

export const Root = styled.div<StyledMods<Pick<AttachmentCellProps, 'invalid'>>>`
    ${mods.invalid.true`
        color: #923924;
    `}
`;
